import { WRBericht } from "./bericht";
import { WRAntrag } from "./antrag";
import { v4 as uuidv4 } from 'uuid';

export class WRInitiative
{
    id: string;
    berichte: Array<WRBericht>;
    antraege: Array<WRAntrag>;
    status: WRInitiativeStatus;

    constructor(berichte: Array<WRBericht>, antraege: Array<WRAntrag>)
    {
        this.id = uuidv4();
        this.berichte = berichte;
        this.antraege = antraege;
        this.status = WRInitiativeStatus.IN_VORBEREITUNG;
    }
}

export enum WRInitiativeStatus {
    IN_VORBEREITUNG,
    IN_EINBRINGUNG,
    IN_PRUEFUNG,
    IN_DISKUSSION,
    IN_ABSTIMMUNG,
    VERABSCHIEDET,
    ABGELEHNT,
    IN_UMSETZUNG
}
  
